import { combineReducers } from 'redux';
import physicalList from './PhysicalList/reducer';
import createEditPhysical from './CreateEditPhysical/reducer';

export default combineReducers({
  physicalList,
  createEditPhysical,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/reducers.js